var xhr = require('../utils/xhr');

module.exports = {
    getComments: function(callback) {
        xhr.simpleCall({
            func: 'comments'
        }, function (res) {
            callback(res.data);
        });
    }
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/modules/comment/service.js
 ** module id = 34
 ** module chunks = 0
 **/